import {Injectable,} from '@angular/core';
import {Logger,} from '@services/log/logger';
import {StringUtil, DateUtil,} from '@services/index';
import {ValidationService,} from '@services/validation/validation.service';
import {ChangeTypeUtil, MessageProvider, SystemConstant,} from '@services/index';
import {CheckValByrefArgVO,} from '@business-common/business-common-vo/check-val-byref-arg-vo';
import {ChkValByrefArgVO,} from '@models/index';

/**
 * Inputcheckユーティリティー
 */
@Injectable({
  providedIn: 'root',
})
export class InputCheck {
  private validationService!: ValidationService; // Validationユーティリティー

  constructor(
    private logger: Logger,
    private stringUtil: StringUtil,
    private changeTypeUtil: ChangeTypeUtil,
    private messageProvider: MessageProvider,
    private dateUtil: DateUtil
  ) {
    this.validationService = new ValidationService(messageProvider, logger, stringUtil, this, dateUtil);
  }

  /**
   * [一般開発者利用可]
   * 携帯電話番号チェック(色づけ)
   *
   * @param {string} val1 携帯電話番号1オブジェクト
   * @param {string} val2 携帯電話番号2オブジェクト
   * @param {string} val3 携帯電話番号3オブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isKeitaiTelNoLen(val1: string, val2: string, val3: string): boolean {
    this.logger.debug('■携帯電話番号チェック(色づけ)処理を開始');

    //値が空白のため入力チェック処理を行わない
    if (val1 === SystemConstant.EMPTY && val2 === SystemConstant.EMPTY && val3 === SystemConstant.EMPTY) {
      this.logger.debug('■携帯電話番号チェック(色づけ)処理を終了');
      return true;
    }

    //携帯電話番号チェック実施
    if (this.validationService.isKeitaiTelNo(val1, val2, val3)) {
      this.logger.debug('■携帯電話番号チェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■携帯電話番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 物件名チェック(色づけ)
   *
   * @param chkObj 物件名テキストオブジェクト
   * @return チェック結果(true:チェックOK、false:チェックNG)
   */
  isBldgNameZenkakuLen(chkObj: string): boolean {
    this.logger.debug('■物件名チェック(色づけ)処理を開始');

    // 値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■物件名チェック(色づけ)処理を終了');
      return true;
    }

    // 物件名チェック実施
    if (this.validationService.isBldgNameZenkaku(chkObj)) {
      this.logger.debug('■物件名チェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■物件名チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 番地号チェック(色づけ)
   * @param {string} chkObj 番地号テキストオブジェクト
   * @return
   *    チェック結果(true:チェックOK、false:チェックNG)
   */
  isAddName3ZenkakuLen(chkObj: string): boolean {
    this.logger.debug('■番地号チェック(色づけ)処理を開始');

    // 値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■番地号チェック(色づけ)処理を終了');
      return true;
    }

    // 郵便番号チェック実施
    if (this.validationService.isAddName3Zenkaku(chkObj)) {
      this.logger.debug('■番地号チェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■番地号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 建物名などチェック(色づけ)
   * @param {string} chkObj 建物名などテキストオブジェクト
   * @return
   *    チェック結果(true:チェックOK、false:チェックNG)
   */
  isAddName4ZenkakuLen(chkObj: string): boolean {
    this.logger.debug('■建物名などチェック(色づけ)処理を開始');

    // 値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■建物名などチェック(色づけ)処理を終了');
      return true;
    }

    // 建物名などチェック実施
    if (this.validationService.isAddName4Zenkaku(chkObj)) {
      this.logger.debug('■建物名などチェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■建物名などチェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 会社名カナチェック(色づけ)
   * @param {string} chkObj 会社名カナテキストオブジェクト
   * @return
   *    チェック結果(true:チェックOK、false:チェックNG)
   */
  isCompanyNameKanaLen(chkObj: string): boolean {
    this.logger.debug('■会社名カナチェック(色づけ)処理を開始');

    // 値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■会社名カナチェック(色づけ)処理を終了');
      return true;
    }

    // 会社名カナチェック実施
    if (this.validationService.isCompanyNameKana(chkObj)) {
      this.logger.debug('■会社名カナチェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■会社名カナチェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 会社名チェック(色づけ)
   * @param {string} chkObj 会社名テキストオブジェクト
   * @return
   *    チェック結果(true:チェックOK、false:チェックNG)
   */
  isCompanyNameZenkakuLen(chkObj: string): boolean {
    this.logger.debug('■会社名チェック(色づけ)処理を開始');

    // 値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■会社名チェック(色づけ)処理を終了');
      return true;
    }

    // 郵便番号チェック実施
    if (this.validationService.isCompanyNameZenkaku(chkObj)) {
      this.logger.debug('■会社名チェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■会社名チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 部屋番号チェック(色づけ)
   *
   * @param {string} chkObj 部屋番号テキストオブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isRoomNameZenkakuLen(chkObj: string): boolean {
    this.logger.debug('■部屋番号チェック(色づけ)処理を開始');

    //値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■部屋番号チェック(色づけ)処理を終了');
      return true;
    }

    if (this.validationService.isRoomNoZenkaku(chkObj)) {
      this.logger.debug('■部屋番号チェック(色づけ)処理を終了');
      return true;
    }

    //部屋番号チェック実施
    this.logger.debug('■部屋番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 部屋番号チェック(色づけ)
   *
   * @param {string} chkObj 部屋番号テキストオブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isRoomNoZenkakuLen(chkObj: string): boolean {
    this.logger.debug('■部屋番号チェック(色づけ)処理を開始');
    //値が空白のため入力チェック処理を行わない
    if (chkObj === SystemConstant.EMPTY) {
      this.logger.debug('■部屋番号チェック(色づけ)処理を終了');
      return true;
    }

    //部屋番号チェック実施
    if (this.validationService.isRoomNoZenkaku(chkObj)) {
      this.logger.debug('■部屋番号チェック(色づけ)処理を終了');
      return true;
    }

    this.logger.debug('■部屋番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 電話番号チェック(色づけ)
   *
   * @param {string} val1 電話番号1オブジェクト
   * @param {string} val2 電話番号2オブジェクト
   * @param {string} val3 電話番号3オブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isTelNoLen(val1: string, val2: string, val3: string): boolean {
    this.logger.debug('■電話番号チェック(色づけ)処理を開始');

    //値が空白のため入力チェック処理を行わない
    if (val1 === SystemConstant.EMPTY && val2 === SystemConstant.EMPTY && val3 === SystemConstant.EMPTY) {
      this.logger.debug('■電話番号チェック(色づけ)処理を終了');
      return true;
    }

    //電話番号チェック実施
    if (this.validationService.isTelNo(val1, val2, val3)) {
      this.logger.debug('■電話番号チェック(色づけ)処理を終了');
      return true;
    }

    this.logger.debug('■電話番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 運転免許番号チェック(色づけ)
   *
   * @param {string} val1 運転免許番号テキストオブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isUntenMenkyoNoLen(val1: string): boolean {
    this.logger.debug('■運転免許番号チェック(色づけ)処理を開始');

    //値が空白のため入力チェック処理を行わない
    if (val1 === SystemConstant.EMPTY) {
      this.logger.debug('■運転免許番号チェック(色づけ)処理を終了');
      return true;
    }

    //郵便番号チェック実施
    if (this.validationService.isUntenMenkyoNo(val1)) {
      this.logger.debug('■運転免許番号チェック(色づけ)処理を終了');
      return true;
    }

    this.logger.debug('■運転免許番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 郵便番号チェック(色づけ)
   *
   * @param {string} val1 郵便番号1オブジェクト
   * @param {string} val2 郵便番号2オブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isZipCodeLen(val1: string, val2: string): boolean {
    this.logger.debug('■郵便番号チェック(色づけ)処理を開始');

    //値が空白のため入力チェック処理を行わない
    if (val1 === SystemConstant.EMPTY && val2 === SystemConstant.EMPTY) {
      this.logger.debug('■郵便番号チェック(色づけ)処理を終了');
      return true;
    }

    //郵便番号チェック実施
    if (this.validationService.isZipCode(val1, val2)) {
      this.logger.debug('■郵便番号チェック(色づけ)処理を終了');
      return true;
    }

    this.logger.debug('■郵便番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 口座名義（カナ）（引当用振込人名カナ用）
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @returns
   *  チェック結果(true:チェックOK、false:チェックNG)
   */
  isKozaNameKanaNotSpaceLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■口座名義（カナ）（引当用振込人名カナ用）チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === '') {
      this.logger.debug('■口座名義（カナ）（引当用振込人名カナ用）チェック処理を終了');
      return true;
    }

    // 口座名義（カナ）（引当用振込人名カナ用）チェックの実施
    if (!this.validationService.isKozaNameKanaNotSpace(chkVal)) {
      this.logger.debug('■口座名義（カナ）（引当用振込人名カナ用）チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■口座名義（カナ）（引当用振込人名カナ用）チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■口座名義（カナ）（引当用振込人名カナ用）チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 引数ログ出力
   *
   * @param chkVal チェック対象文字列
   * @param maxLen 最大Byte数
   * @param minLen 最小Byte数
   *
   */
  logOutputArgument(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): void {
    this.logger.debug('■引数ログ出力処理を開始');
    // 引数出力
    this.logger.debug('入力値：' + this.changeTypeUtil.nothingToString(chkVal));
    if (this.changeTypeUtil.nullToInteger(maxLen) === 0) {
      this.logger.debug('最大Byte数：設定なし');
    } else {
      this.logger.debug('最大Byte数：' + maxLen);
    }
    if (this.changeTypeUtil.nullToInteger(minLen) === 0) {
      this.logger.debug('最小Byte数：設定なし');
    } else {
      this.logger.debug('最小Byte数：' + minLen);
    }
    this.logger.debug('■引数ログ出力処理を終了');
  }

  /**
   * [一般開発者利用可]
   * 文字数チェック
   *
   * @param {string} val チェック文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return
   *  下限の値が未入力の場合は「チェック文字列 = 上限Byte数」で判定
   *  文字数のチェックはByteでチェック
   *
   */
  lengthCheck(val: string, maxLen: number | null | undefined, minLen: number | null | undefined): boolean {
    let len = 0;
    this.logger.debug('■文字数チェック開始');
    if (val == null) {
      this.logger.debug('■文字数チェック：NG');
      throw Error();
    }
    len = this.validationService.getByteLength(val);

    if (minLen == null || minLen === 0) {
      // 「チェック文字列 = 上限Byte数」か判定
      if (maxLen == null || len !== maxLen) {
        this.logger.debug('■文字数チェック：NG');
        this.logger.debug('■文字数チェック終了');
        return false;
      }
    } else {
      if (maxLen == null || len < minLen || len > maxLen) {
        this.logger.debug('■文字数チェック：NG');
        this.logger.debug('■文字数チェック終了');
        return false;
      }
    }
    this.logger.debug('■文字数チェック：OK');
    this.logger.debug('■文字数チェック終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 口座名義（カナ）チェック(色づけ)
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return
   *    チェック結果(true:チェックOK、false:チェックNG)
   */
  isKozaNameKanaLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■口座名義（カナ）チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■口座名義（カナ）チェック処理を終了');
      return true;
    }

    // 口座名義（カナ）チェックの実施
    if (!this.validationService.isKozaNameKana(chkVal)) {
      this.logger.debug('■口座名義（カナ）チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■口座名義（カナ）チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■口座名義（カナ）チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 日付のFrom～Toチェック
   * @param {string} wkDateFrom 日付のFrom
   * @param {string} wkDateTo 日付のTo
   * @return
   *    チェック結果(true:チェックOK、false:チェックNG)
   */
  isDateFromToChk(wkDateFrom: string, wkDateTo: string): boolean {
    let isDateFromToChk = true;
    this.logger.debug('■日付のFrom～Toチェック処理を開始');

    // 値の有無確認
    if (
      wkDateFrom == null ||
      wkDateFrom === SystemConstant.EMPTY ||
      wkDateTo == null ||
      wkDateTo === SystemConstant.EMPTY
    ) {
      this.logger.debug('チェック結果：' + isDateFromToChk);
      this.logger.debug('■日付のFrom～Toチェック処理を終了');
      return isDateFromToChk;
    }

    // 引数ログ出力
    this.logger.debug('チェック日付From：' + wkDateFrom);
    this.logger.debug('チェック日付To：' + wkDateTo);

    if (wkDateFrom > wkDateTo) {
      isDateFromToChk = false;
      this.logger.debug('チェック結果：' + isDateFromToChk);
      this.logger.debug('■日付のFrom～Toチェック処理を終了');
      return isDateFromToChk;
    }
    this.logger.debug('チェック結果：' + isDateFromToChk);
    this.logger.debug('■日付のFrom～Toチェック処理を終了');
    return isDateFromToChk;
  }

  /**
   * [一般開発者利用可]
   * 全角カナと（）チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isAllKanaLen(chkVal: string, maxLen: number | null | undefined = 0, minLen: number | null | undefined = 0): boolean {

    this.logger.debug('■全角カナと（）チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角カナと（）チェック処理を終了');
      return true;
    }

    // 全角カナと（）チェックの実施
    if (!this.validationService.isAllKana(chkVal)) {
      this.logger.debug('■全角カナと（）チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■全角カナと（）チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角カナと（）チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角アルファベットと空白チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isAlphabetSpaceLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {

    this.logger.debug('■全角アルファベットと空白チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 2連続空白削除
    chkVal = this.validationService.fncSpaceCheck(chkVal);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角アルファベットと空白チェック処理を終了');
      return true;
    }

    // 全角アルファベットと空白チェックの実施
    if (!this.validationService.isAlphabetSpace(chkVal)) {
      this.logger.debug('■全角アルファベットと空白チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■全角アルファベットと空白チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角アルファベットと空白チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * SHIFT-JISチェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isExistInSjisLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {

    this.logger.debug('■SHIFT-JISチェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■SHIFT-JISチェック処理を終了');
      return true;
    }

    // SHIFT-JISチェックの実施
    if (!this.validationService.existInSjis(chkVal)) {
      this.logger.debug('■SHIFT-JISチェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■SHIFT-JISチェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■SHIFT-JISチェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 半角文字チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isHankakuLen(chkVal: string, maxLen: number | null | undefined = 0, minLen: number | null | undefined = 0): boolean {

    this.logger.debug('■半角文字チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■半角文字チェック処理を終了');
      return true;
    }

    // 半角文字チェックの実施
    if (!this.validationService.isHankaku(chkVal)) {
      this.logger.debug('■半角文字チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■半角文字チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■半角文字チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 半角カナチェック
   *
   * @param chkVal チェック対象文字列
   * @param maxLen 最大Byte数
   * @param minLen 最小Byte数
   * @return チェック結果(True:チェックOK、False:チェックNG)
   *
   */
  isHankakuKanaLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {

    this.logger.debug('■半角カナチェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■半角文字チェック処理を終了');
      return true;
    }

    // 半角カナチェックの実施
    if (!this.validationService.isHankakuKana(chkVal)) {
      this.logger.debug('■半角文字チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■半角文字チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■半角文字チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェック
   *
   * @param chkVal チェック対象文字列
   * @param maxLen 最大Byte数
   * @param minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isHankakuWithoutKigoLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェック処理を終了');
      return true;
    }

    // 半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェックの実施
    if (!this.validationService.isHankakuWithoutKigo(chkVal)) {
      this.logger.debug('■半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■半角数字,半角カナ,半角アルファベット,半角スペース,半角ハイフンチェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角カナチェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isKanaLen(chkVal: string, maxLen: number | null | undefined = 0, minLen: number | null | undefined = 0): boolean {

    this.logger.debug('■全角カナチェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角カナチェック処理を終了');
      return true;
    }

    // 全角カナチェックの実施
    if (!this.validationService.isKana(chkVal)) {
      this.logger.debug('■全角カナチェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■全角カナチェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角カナチェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角カナと空白チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(true:チェックOK、false:チェックNG)
   *
   */
  isKanaSpaceLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {

    this.logger.debug('■全角カナと空白チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 2連続空白削除
    chkVal = this.validationService.fncSpaceCheck(chkVal);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角カナと空白チェック処理を終了');
      return true;
    }

    // 全角カナと空白チェックの実施
    if (!this.validationService.isKanaSpace(chkVal)) {
      this.logger.debug('■全角カナと空白チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■全角カナと空白チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角カナと空白チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 負の数を認める半角数字チェック
   *
   * @param {string} value チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return
   * チェック結果(True:チェックOK、False:チェックNG)
   * MaxLen：文字数チェックを行う場合は設定すること
   * MinLen：文字数チェックを行う場合は設定すること
   * MaxLenのみに値を設定した場合は「チェック文字数 = MaxLen」の判定を行う
   */
  isMinusNumberLen(
    value: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■負の数を認める半角数字チェック処理を開始');

    //引数ログ出力
    this.logOutputArgument(value, maxLen, minLen);

    //値が空白のため入力チェック処理を行わない
    if (value === SystemConstant.EMPTY) {
      this.logger.debug('■負の数を認める半角数字チェック処理を終了');
      return true;
    }

    //負の数を認める半角数字チェックの実施
    if (!this.validationService.isMinusNumber(value)) {
      this.logger.debug('■負の数を認める半角数字チェック処理を終了');
      return false;
    }
    //文字数チェック
    if (maxLen!= null && maxLen !== 0) {
      if (!this.lengthCheck(value, maxLen, minLen)) {
        this.logger.debug('■負の数を認める半角数字チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■負の数を認める半角数字チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * MP契約番号チェック(色づけ)
   *
   * @param {string} chkVal MP契約番号テキストオブジェクト
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isMPKeiyakuNoLen(chkVal: string): boolean {
    this.logger.debug('■MP契約番号チェック(色づけ)処理を開始');

    //値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■MP契約番号チェック(色づけ)処理を終了');
      return true;
    }

    //MP契約番号チェック実施
    if (this.validationService.isMPKeiyakuNo(chkVal)) {
      this.logger.debug('■MP契約番号チェック(色づけ)処理を終了');
      return true;
    }
    this.logger.debug('■MP契約番号チェック(色づけ)処理を終了');
    return false;
  }

  /**
   * [一般開発者利用可]
   * 半角数字と小数点チェック(色づけ)
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} intLen 整数部の文字数
   * @param {number} decLen 小数部の文字数
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   *
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isNumberAndPeriodLen(
    chkVal: string,
    intLen: number | null | undefined,
    decLen: number | null | undefined,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    intLen = this.changeTypeUtil.nullToNumber(intLen);
    decLen = this.changeTypeUtil.nullToNumber(decLen);

    this.logger.debug('■半角数字と小数点チェックチェック処理を開始');

    //引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);
    this.logger.debug('整数部の文字数：' + intLen);
    this.logger.debug('小数部の文字数：' + decLen);

    //値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■半角数字と小数点チェック処理を終了');
      return true;
    }

    //半角数字と小数点チェックの実施
    if (!this.validationService.isNumberAndPeriodWithSize(chkVal, intLen, decLen)) {
      this.logger.debug('■半角数字と小数点チェック処理を終了');
      return false;
    }

    //文字数チェック
    if (maxLen!= null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■半角数字と小数点チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■半角数字と小数点チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 半角数字チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   *
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isOnlyNumberLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■半角数字チェック処理を開始');
    //引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    //値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■半角数字チェック処理を終了');
      return true;
    }

    //半角数字チェックの実施
    if (!this.validationService.isNumeric(chkVal)) {
      this.logger.debug('■半角数字チェック処理を終了');
      return false;
    }

    //文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■半角数字チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■半角数字チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角文字と空白チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isZenkakuLen(
    checkValVO: CheckValByrefArgVO,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■全角文字と空白チェック処理を開始');
    // 引数ログ出力
    this.logOutputArgument(checkValVO.chkVal, maxLen, minLen);

    // 2連続空白削除
    checkValVO.chkVal = this.validationService.fncSpaceCheck(checkValVO.chkVal);

    // 値が空白のため入力チェック処理を行わない
    if (checkValVO.chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角文字と空白チェック処理を終了');
      return true;
    }
    // 全角文字と空白チェックの実施
    if (!this.validationService.isZenkaku(checkValVO.chkVal)) {
      this.logger.debug('■全角文字と空白チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen!= null && maxLen !== 0) {
      if (!this.lengthCheck(checkValVO.chkVal, maxLen, minLen)) {
        this.logger.debug('■全角文字と空白チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角文字と空白チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角文字チェック
   *
   * @param {string} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isZenkakuWithoutBlankLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {

    this.logger.debug('■全角文字チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角文字チェック処理を終了');
      return true;
    }

    // 全角文字チェックの実施
    if (!this.validationService.isZenkakuWithoutBlank(chkVal)) {
      this.logger.debug('■全角文字チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■全角文字チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角文字チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角文字と記号と空白チェック
   *
   * @param {ChkValByrefArgVO} chkVal チェック対象文字列
   * @param {number} maxLen 最大Byte数
   * @param {number} minLen 最小Byte数
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isZenkakuAndKigoLen(
    chkVal: ChkValByrefArgVO,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■全角文字と記号と空白チェック処理を開始');

    // 引数ログ出力
    if (chkVal.chkVal != null) {
      this.logOutputArgument(chkVal.chkVal, maxLen, minLen);
    }

    // 2連続空白削除
    chkVal.chkVal = this.validationService.fncSpaceCheck(chkVal.chkVal);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal.chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角文字と記号と空白チェック処理を終了');
      return true;
    }

    // 全角文字と記号と空白チェックの実施
    if (!this.validationService.isZenkakuAndKigo(chkVal.chkVal)) {
      this.logger.debug('■全角文字と記号と空白チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen != null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal.chkVal, maxLen, minLen)) {
        this.logger.debug('■全角文字と記号と空白チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角文字と記号と空白チェック処理を終了');
    return true;
  }

  /**
   * [一般開発者利用可]
   * 全角文字と記号（""．""含む）と空白チェック
   *
   * @param chkVal チェック対象文字列
   * @param maxLen 最大Byte数
   * @param minLen 最小Byte数
   * @return チェック結果(True:チェックOK、False:チェックNG)
   */
  isZenkakuAndKigoForShouhinLen(
    chkVal: string,
    maxLen: number | null | undefined = 0,
    minLen: number | null | undefined = 0
  ): boolean {
    this.logger.debug('■全角文字と記号（"．"含む）と空白チェック処理を開始');

    // 引数ログ出力
    this.logOutputArgument(chkVal, maxLen, minLen);

    // 2連続空白削除
    chkVal = this.validationService.fncSpaceCheck(chkVal);

    // 値が空白のため入力チェック処理を行わない
    if (chkVal === SystemConstant.EMPTY) {
      this.logger.debug('■全角文字と記号（"．"含む）と空白チェック処理を終了');
      return true;
    }

    // 全角文字と記号（""．""含む）と空白チェックの実施
    if (!this.validationService.isZenkakuAndKigoForShouhin(chkVal)) {
      this.logger.debug('■全角文字と記号（"．"含む）と空白チェック処理を終了');
      return false;
    }

    // 文字数チェック
    if (maxLen!= null && maxLen !== 0) {
      if (!this.lengthCheck(chkVal, maxLen, minLen)) {
        this.logger.debug('■全角文字と記号（"．"含む）と空白チェック処理を終了');
        return false;
      }
    }
    this.logger.debug('■全角文字と記号（"．"含む）と空白チェック処理を終了');
    return true;
  }
}
